import { FiInstagram, FiFacebook } from 'react-icons/fi';

import { useAuth } from '../../hooks/auth';

/* Styles */
import {
  Button,
  Container,
  LeftContent,
  MidContent,
  RightContent,
} from './styles';

import logo from '../../assets/img/logoGrid.png';

const Footer = () => {
  const { user } = useAuth();

  return (
    <Container>
      <LeftContent>
        <img src={logo} alt="logo" />
      </LeftContent>
      <MidContent>
        <span>
          {!user && (
            <>
              <Button>
                <p>Cadastrar</p>
              </Button>
              <Button>
                <p>Fazer login</p>
              </Button>
            </>
          )}
          <Button>
            <p>Visite o nosso site</p>
          </Button>
        </span>
        <p>EDITORA ARECREATIVA 2022&copy; - Todos direitos reservados</p>
      </MidContent>
      <RightContent>
        <h1>
          CRÍTICAS E <br />
          SUGESTÕES
        </h1>
        <p>- FALE CONOSCO</p>
        <div>
          <a
            href="https://www.instagram.com/arecreativa/"
            target="_blank"
            rel="noreferrer"
          >
            <FiInstagram size={25} />
          </a>
          <a
            href="https://www.facebook.com/ARecreativa/"
            target="_blank"
            rel="noreferrer"
          >
            <FiFacebook size={25} />
          </a>
        </div>
      </RightContent>
    </Container>
  );
};

export default Footer;
